module.exports = __webpack_public_path__ + "static/media/Программа УОМШ-2026-new.dc156a63.pdf";